import React from "react";
import { useQuery } from "react-query";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
  Typography,
  Box,
  TextField,
} from "@material-ui/core";
import axios from "axios"; // or your API service helper
import { useGetAllModules } from "../../../projectManagementQueries";
import { TravelerModal } from "../../../../common/travelerModal";
import { useupdateUnitsRequiredField } from "../../../projectManagementMutations";
import { useFetchContext } from "../../../../common/FetchContext";
import { toast } from "react-toastify";

interface TSDModulesDialogProps {
  open: boolean;
  onClose: () => void;
  tsdId: string | null;
  workorderId?: string;
}

export const TSDModulesDialog = ({
  open,
  onClose,
  tsdId,
  workorderId,
}: TSDModulesDialogProps) => {
  // Query runs automatically when open is true and tsdId exists

  const { authAxios } = useFetchContext();

  const { data, isLoading, isError, error } = useGetAllModules(
    tsdId || "",
    workorderId || "",
  );

  const { mutateAsync: updateUnitsRequiredField, isLoading: isUpdating } =
    useupdateUnitsRequiredField();

  const [requiredUnits, setRequiredUnits] = React.useState<number | "">("");
  React.useEffect(() => {
    if (data?.required_units !== undefined) {
      setRequiredUnits(data?.required_units);
    }
  }, [data?.required_units]);
  const handleClose = () => {
    setRequiredUnits(data?.required_units ?? 0);
    onClose();
  };
  const handleRequiredUnitsChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;

    if (value === "") {
      setRequiredUnits("");
      return;
    }

    setRequiredUnits(Number(value));
  };

  const handleSave = async () => {
    console.log("Updated required units:", requiredUnits);
    console.log("tsdid workorderid", tsdId, workorderId);

    try {
      const updatedData = await updateUnitsRequiredField({
        authAxios,
        tsdId,
        workOrderId: workorderId,
        units_required: requiredUnits,
        test_sequence: tsdId,
      });
    } catch (err) {
      toast.error("Failed to update units required. Please try again.");
    }
    // Call your update API here
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Assigned Modules</DialogTitle>

      <DialogContent dividers>
        {isLoading ? (
          <Box display="flex" justifyContent="center" p={3}>
            <CircularProgress />
          </Box>
        ) : isError ? (
          <Typography color="error" align="center">
            Failed to load modules:{" "}
            {(error as Error)?.message || "Unknown error"}
          </Typography>
        ) : (
          <>
            {/* Required Units */}
            <Box mb={3}>
              <TextField
                label="Required Units"
                value={requiredUnits}
                onChange={handleRequiredUnitsChange}
                type="number"
                variant="outlined"
                fullWidth
                inputProps={{
                  min: 0,
                }}
              />
            </Box>

            {/* Assigned Units */}
            <Typography variant="subtitle1" gutterBottom>
              Assigned Units
            </Typography>

            {data?.assigned_units?.length === 0 ? (
              <Typography color="textSecondary">
                No modules currently assigned.
              </Typography>
            ) : (
              <Box display="flex" flexWrap="wrap" style={{ gap: "8px" }}>
                {data?.assigned_units?.map((module: string, index: number) => (
                  <TravelerModal key={module || index} serialNumber={module} />
                ))}
              </Box>
            )}
          </>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color="secondary" variant="contained">
          Close
        </Button>
        <Button
          onClick={handleSave}
          color="primary"
          variant="contained"
          disabled={isUpdating}
        >
          {isUpdating ? <CircularProgress size={20} /> : "Update"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
